
    import './styles.scoped.css';
    export default {
  "tutorial-list": "awsui_tutorial-list_1u70p_gpt1a_93",
  "tutorial-title": "awsui_tutorial-title_1u70p_gpt1a_130",
  "task": "awsui_task_1u70p_gpt1a_137",
  "task-title": "awsui_task-title_1u70p_gpt1a_145",
  "task-title--status": "awsui_task-title--status_1u70p_gpt1a_153",
  "current-task": "awsui_current-task_1u70p_gpt1a_157",
  "successful-task": "awsui_successful-task_1u70p_gpt1a_161",
  "congratulation-message": "awsui_congratulation-message_1u70p_gpt1a_165",
  "congratulation-message--status": "awsui_congratulation-message--status_1u70p_gpt1a_173",
  "plaintext-congratulation-description": "awsui_plaintext-congratulation-description_1u70p_gpt1a_177",
  "divider": "awsui_divider_1u70p_gpt1a_181",
  "step-list": "awsui_step-list_1u70p_gpt1a_185",
  "step": "awsui_step_1u70p_gpt1a_185",
  "expandable-section-wrapper": "awsui_expandable-section-wrapper_1u70p_gpt1a_194",
  "expandable-section-header": "awsui_expandable-section-header_1u70p_gpt1a_198",
  "step-title": "awsui_step-title_1u70p_gpt1a_203",
  "feedback-link": "awsui_feedback-link_1u70p_gpt1a_204",
  "dismiss-button": "awsui_dismiss-button_1u70p_gpt1a_205",
  "completion-screen-title": "awsui_completion-screen-title_1u70p_gpt1a_206",
  "completion-screen-description": "awsui_completion-screen-description_1u70p_gpt1a_207"
};
  